import { alpha, type Theme } from "@mui/material";
import {
	DANGER_MYPLANN_LIGHT,
	DANGER_TERTIARY,
	GRASS_GREEN_MYPLANN,
	LIGHT_GREEN_MYPLANN,
} from "web_myplann/Utils/constants";

type ChipColors = { bg: string; delta: string };

export const getEvaluationChipColors = (
	palette: Theme["palette"],
	hasGoalsRight: boolean,
	isNearZero: boolean,
	isPositive: boolean,
): ChipColors => {
	const white = palette.darkmodeText.white;

	if (hasGoalsRight) {
		return {
			bg:
				isNearZero || isPositive
					? alpha(white, 0.2)
					: alpha(palette.red[500], 0.3),
			delta: white,
		};
	}
	if (isNearZero) {
		return {
			bg: palette.deprecated.grey[400],
			delta: palette.darkmodeText.white,
		};
	}
	if (isPositive) {
		return { bg: LIGHT_GREEN_MYPLANN, delta: GRASS_GREEN_MYPLANN };
	}
	return { bg: DANGER_TERTIARY, delta: DANGER_MYPLANN_LIGHT };
};
